import React from 'react'

import { createSvgIcon } from './utils/create-svg-icon'

export const WindowIcon = createSvgIcon(
  <>
    <title>window</title>
    <g
      className="nc-icon-wrapper"
      fill="#222222"
      stroke="#222222"
      strokeLinecap="square"
      strokeLinejoin="miter"
      strokeWidth="1"
      transform="translate(0.5 0.5)"
    >
      <rect
        data-color="color-2"
        fill="none"
        height="8"
        strokeMiterlimit="10"
        width="8"
        x="5"
        y="14"
      />{' '}
      <line
        data-color="color-2"
        fill="none"
        strokeMiterlimit="10"
        x1="17"
        x2="27"
        y1="15"
        y2="15"
      />{' '}
      <line
        data-color="color-2"
        fill="none"
        strokeMiterlimit="10"
        x1="17"
        x2="23"
        y1="19"
        y2="19"
      />{' '}
      <rect
        fill="none"
        height="26"
        stroke="#222222"
        strokeMiterlimit="10"
        width="30"
        x="1"
        y="3"
      />{' '}
      <line
        fill="none"
        stroke="#222222"
        strokeMiterlimit="10"
        x1="1"
        x2="31"
        y1="8"
        y2="8"
      />{' '}
      <line
        fill="none"
        stroke="#222222"
        strokeMiterlimit="10"
        x1="7"
        x2="7"
        y1="3"
        y2="8"
      />
    </g>
  </>
)
